"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import Filehuman from "assets/images/filehuman.svg";
import ErrorBaseTemplate from "templates/ErrorBaseTemplate";
import { Button } from "uiShadcn/button";
interface ErrorPageProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function ErrorPage(t0) {
  const $ = _c(19);
  const {
    error,
    reset
  } = t0;
  const {
    formatMessage
  } = useIntl();
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== formatMessage) {
    t3 = formatMessage({
      id: "something_went_wrong"
    });
    $[3] = formatMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== formatMessage) {
    t4 = formatMessage({
      id: "something_went_wrong_desc"
    });
    $[5] = formatMessage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== reset) {
    t5 = () => reset();
    $[7] = reset;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== formatMessage) {
    t6 = formatMessage({
      id: "try_again"
    });
    $[9] = formatMessage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <Button type="button" dataTestId="button_try_again" onClick={t5} variant="destructive" className="w-full md:max-w-[256px]">{t6}</Button>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pt-n16"><Filehuman aria-hidden="true" /></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t7) {
    t9 = <ErrorBaseTemplate title={t3} description={t4}>{t7}{t8}</ErrorBaseTemplate>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}